import { render, staticRenderFns } from "./PriceCell.vue?vue&type=template&id=b1f8956a&scoped=true"
import script from "./PriceCell.vue?vue&type=script&lang=js"
export * from "./PriceCell.vue?vue&type=script&lang=js"
import style0 from "./PriceCell.vue?vue&type=style&index=0&id=b1f8956a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f8956a",
  null
  
)

export default component.exports